import React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";

import { IUserData, getUserData } from "../sessionStorage";

import KVALogoWide from "./KVALogoWide";
import MembershipBadge from "./MembershipBadge";

interface IHeadStripeProps {
  helloLine: string;
}

export default function HeadStripe(props: IHeadStripeProps) {
  let userData = getUserData();
  let clientNumber = "???";

  if (userData) {
    const parsed: IUserData = JSON.parse(userData);
    clientNumber = parsed ? parsed.clientNumber : "???";
  }

  return (
    <>
      <Row className="align-items-center">
        <Col xs={4} lg={4} xl={4}>
          <a className="navbar-brand" href="#">
            <KVALogoWide />
          </a>
        </Col>
        <Col xs={5} lg={4} xl={4} className="text-center">
          <div className="welcome-txt">
            {props.helloLine}
            <span>Mandantennummer {clientNumber || "???"}</span>
          </div>
        </Col>
        <Col xs={2} lg={4} xl={4} className="text-lg-right">
          <MembershipBadge level={3} />
        </Col>
        <Col xs={1} className="d-block d-lg-none text-right">
          <Navbar.Toggle
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-expanded="false"
            aria-controls="navbarResponsive"
          >
            <span className="icon-bar top-bar" />
            <span className="icon-bar middle-bar" />
            <span className="icon-bar bottom-bar" />
          </Navbar.Toggle>
        </Col>
      </Row>
    </>
  );
}
